import { IGroupDividerProps, IRenderFunction } from "@fluentui/react";

/**
 * Group header renderer that makes a click on the header row (title, count, padding)
 * expand or collapse the group.
 *
 * Fluent's GroupHeader already paints the title with `cursor: pointer`, but its row click
 * only ever falls back to "select every row in the group", which does nothing outside
 * SelectionMode.multiple. In a single-select grid that leaves a dead click behind a
 * pointer cursor. `onGroupHeaderClick` is Fluent's hook for the row click, and the
 * `onToggleCollapse` it hands us here is GroupedList's own toggle (the one the chevron
 * calls), so routing one to the other keeps the collapse state in sync and re-renders
 * the list. The chevron and the selection checkbox stop propagation themselves, so they
 * keep toggling exactly once.
 *
 * Only use this on grids where the header click has no other job: in a multi-select
 * grid the row click selects the group, and that behaviour should stay.
 */
export const renderCollapsibleGroupHeader: IRenderFunction<IGroupDividerProps> = (props, defaultRender) => {
    if (!defaultRender || !props) {
        return null;
    }
    return defaultRender({
        ...props,
        onGroupHeaderClick: group => props.onToggleCollapse?.(group),
    });
};
